import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../services/auth.service';

@Injectable({
	providedIn: 'root',
})
export class AuthGuard {
	constructor(
		private router: Router,
		private authService: AuthService,
	) {}

	canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		return this.isAuthorised(childRoute);
	}

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		return this.isAuthorised(next);
	}

	isAuthorised(next: ActivatedRouteSnapshot): boolean {
		if (!this.authService.token) {
			this.authService.login();
			return false;
		}

		return true;
	}
}
